module.exports = __webpack_public_path__ + "static/media/facebook_reaction_love.b9063eba.svg";